/** Minimum items to show in the dropdown (fill with read items until total reaches this). */
export const DROPDOWN_MIN_ITEMS = 3

/** Maximum items visible in the dropdown before showing "View All". */
export const DROPDOWN_MAX_ITEMS = 8

/** Delay (ms) before the unread dots start fading out on dropdown open. */
export const AUTO_READ_DELAY_MS = 2000

/** Duration (ms) of the unread dot fade-out animation. */
export const AUTO_READ_FADE_DURATION_MS = 1600

/**
 * NOTIF-3: notification types and their server status.
 *
 * Emitted by the server today:
 *   CHALLENGE_INVITE (postCreateChallenge), CHALLENGE_REMIND (challengesRemind),
 *   CHALLENGE_COMPLETED + CHALLENGE_CANCELED (settlement.service).
 *
 * Reserved (in the Prisma `NotificationType` enum + labelled below, but NOT yet
 * created by any server code path):
 *   CHALLENGE_ACCEPTED, CHALLENGE_DECLINED, CHALLENGE_STARTED,
 *   MATCH_STARTING_SOON, MATCH_RESULT, LEADERBOARD_UPDATE.
 *
 * Labels for reserved types are kept so the UI renders correctly if/when the
 * server starts emitting them. Removing the unused enum values requires a Prisma
 * migration (tracked separately) — do not delete the enum values here.
 */

/** Short labels per notification type for unique badges in the list. */
export const NOTIFICATION_TYPE_LABELS: Record<string, string> = {
  CHALLENGE_INVITE: 'Invite',
  CHALLENGE_ACCEPTED: 'Accepted',
  CHALLENGE_DECLINED: 'Declined',
  CHALLENGE_CANCELED: 'Canceled',
  CHALLENGE_STARTED: 'Started',
  CHALLENGE_REMIND: 'Reminder',
  CHALLENGE_COMPLETED: 'Finished',
  MATCH_STARTING_SOON: 'Soon',
  MATCH_RESULT: 'Result',
  LEADERBOARD_UPDATE: 'Leaderboard',
}

/**
 * Person-centric action text: "[Name] [action]". Short and gamified.
 */
export const NOTIFICATION_ACTION_LABELS: Record<string, string> = {
  CHALLENGE_INVITE: 'challenged you',
  CHALLENGE_ACCEPTED: 'accepted',
  CHALLENGE_DECLINED: 'declined',
  CHALLENGE_CANCELED: 'expired',
  CHALLENGE_STARTED: 'game is on!',
  CHALLENGE_REMIND: 'nudge — lock in your picks!',
  CHALLENGE_COMPLETED: 'results are in!',
  MATCH_STARTING_SOON: 'match soon',
  MATCH_RESULT: 'result in',
  LEADERBOARD_UPDATE: 'leaderboard updated',
}

/** Arena tab path for notification deep link (challenge-related notifications). */
export const ARENA_PATH = '/app/arena'

/**
 * Web: full-screen scrim must stack above `combinedHeader` (z-index 10002) so the header dims with
 * the rest of the screen; keep below `GlobalSnackbar` (10005).
 */
export const NOTIFICATION_DROPDOWN_OVERLAY_Z_INDEX_WEB = 10004 as const
